module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/2-58363f276ce6607c3bc8b8d07fc876ad.png";